import React from "react"
import QuizModeCard from "./quiz_mode_card"
import study_mode_image from "images/quiz/study.png"

function StudyModeCard({is_selected}) {
  return (
    <div className="study-mode">
      <QuizModeCard
        image_path={study_mode_image}
        quiz_mode={"study_mode"}
        is_selected={is_selected}
      />
    </div>
  )
}

export default StudyModeCard
